import { Box, Button, Divider, Menu, MenuItem } from "@mui/material";
import { useState, useEffect } from "react";
import IconUserLg from "../componentsStyled/icon/IconUserLg";
import logoKappa from "../img/kappaLogo.png";
import HeaderTopLinks from "./headerTopLinks";

interface User {
  name: string;
  email: string;
  customerId: string;
  token: string;
}
const Header = () => {
  const [user, setUser] = useState<User>();

  const [isOpen, setIsOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(undefined);

  const handleClick = (event) => {
    setIsOpen(!isOpen);
    setAnchorEl(event.currentTarget);
  };

  const handlelogout = () => {
    localStorage.removeItem("auth");
    window.location.href = "/";
  };

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("auth") || "{}");
    setUser(user);
  }, []);
  return (
    <Box>
      <HeaderTopLinks />
      <Divider variant="fullWidth" sx={{ borderBottomWidth: 2, borderColor: "#DBDBDB" }} />
      <Box display={"flex"} justifyContent={"space-around"} mt={4} mb={4}>
        <Box width={500}>
          <img src={logoKappa} style={{ width: "100%" }} />
        </Box>
        <div className="userLogin">
          {/* handleClick */}
          <Button onClick={handleClick} color="inherit" startIcon={<IconUserLg width={25} />}>
            <p>Olá, {user?.name ?? "Usuário Fut"}</p>
          </Button>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={isOpen}
            onClose={() => setIsOpen(false)}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}>
            <MenuItem onClick={handlelogout}>Logout</MenuItem>
          </Menu>
        </div>
      </Box>
      <Divider variant="fullWidth" sx={{ borderBottomWidth: 2, borderColor: "#DBDBDB" }} />
    </Box>
  );
};
export default Header;
